import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { FormField } from '../../../dto/util/form-field';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-modal-editar-titulo',
  templateUrl: './modal-editar-titulo.component.html',
  styleUrl: './modal-editar-titulo.component.scss',
})
export class ModalEditarTituloComponent {
  @ViewChild('modalTitulo')
  modalTitulo!: ElementRef;
  dominioForm!: FormGroup;
  tituloForm: FormField[] = [
    {
      name: 'titulo',
      label: 'Título',
      type: 'text',
      required: true,
      width: '12',
      visible: true,
      errorMessages: {
        required: 'El título es requerido',
        pattern:
          'Solo se permiten letras, números y guiones (-). Ejemplo: título-1, dos-títulos',
        nameExists: 'Este título ya existe',
      },
    },
  ];

  @Input() tituloConv: string = '';
  @Input() elements: any[] = [];
  @Output() ndEmitter = new EventEmitter<any>();

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    const formControls: any = {};
    this.tituloForm.forEach(field => {
      if (field.visible) {
        formControls[field.name] = [null, []];
      }
    });
    this.dominioForm = this.fb.group(formControls);
    this.dominioForm.patchValue({
      titulo: this.tituloConv,
    });
  }

  createForm(): void {
    const formControls: any = {};
    this.tituloForm.forEach(field => {
      if (field.visible) {
        const validators = [];
        if (field.required) {
          validators.push(Validators.required);
        }
        if (field.name === 'título') {
          validators.push(this.uniqueNameValidator(this.elements));
        }
        formControls[field.name] = [null, validators];
      }
    });
    this.dominioForm = this.fb.group(formControls);
    this.dominioForm.patchValue({
      titulo: this.tituloConv,
    });
  }

  submitForm(): void {
    if (this.dominioForm.valid) {
      this.ndEmitter.emit(this.dominioForm.value);
      this.abrirCerrarModal();
      this.dominioForm.reset();
    } else {
      this.dominioForm.markAllAsTouched();
    }
  }

  getErrorMessage(field: string): string | null {
    const control = this.dominioForm.get(field);
    if (control?.invalid && control.touched) {
      const errorType = Object.keys(control.errors!)[0];
      return (
        this.tituloForm.find(f => f.name === field)?.errorMessages?.[
          errorType
        ] || 'Campo inválido'
      );
    }
    return null;
  }

  uniqueNameValidator(existingElements: any[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;
      const nameExists = existingElements.some(el => {
        if (typeof el === 'string') {
          return el.toLowerCase() === control.value.toLowerCase();
        } else {
          return el.Título.toLowerCase() === control.value.toLowerCase();
        }
      });
      return nameExists ? { nameExists: true } : null;
    };
  }

  abrirCerrarModal() {
    this.createForm();
    this.modalTitulo.nativeElement.click();
  }
}
